import React from 'react';
import { ActivityType } from '../ActivityInfo/ActivityInfo';
import { BadgeAndActivity } from './BadgeAndActivity';
import { Body1Bold } from '../../config/designSystem/typography';
import { IPathModel } from '../../state/stores/Path/PathModel';
import { ISession } from '../../state/stores/Session/SessionModel';
import { MARGIN_BETWEEN_CARDS } from '../../constants/dashboardLayout';
import { ProgramCardWrapper } from './ProgramCardWrapper';
import { branchingKey, dashboardStackKey, pathKey, privateKey, sessionStackKey } from '../../constants/routeKeys';
import { concatPath } from '../../utils/links/concatPath';
import { logAmplitude } from '../../utils/analytics/analytics';
import { observer } from 'mobx-react';
import { router } from 'expo-router';
import { useStores } from '../../hooks/useStores';

export type ProgramBackgroundProps = {
    pathId: string;
    exercisesBelow?: boolean;
    session: ISession;
    showOnboarding?: boolean;
    onboardingCb?: () => void;
    onCloseComplete?: () => void;

}

const _ProgressSessionCard = ({pathId, exercisesBelow, session, showOnboarding=false, onboardingCb,onCloseComplete}: ProgramBackgroundProps) => {
  const rootStore = useStores();
  const path: IPathModel = rootStore.path.getPath(pathId);

  const programExist = rootStore?.path?.programExist;



  const labels = rootStore?.language.translate.MOBILE?.HOME;


  const pathFinishedToday = path?.programFinishedToday;
  const nextSessionExist = programExist && !pathFinishedToday;


  const onPressSession = () => {

    if(nextSessionExist) {
      if(session?.done) {
        router.navigate({
          pathname: concatPath([privateKey, dashboardStackKey, pathKey], -1) as string,
          params: {id: path?._id}
        });
      } else {
        logAmplitude('Session Started', {
          pathId: path?.humanReadableId,
          sessionId: session?.humanReadableId,
          from: 'today_section'
        });
        router.navigate({
          pathname: concatPath([privateKey, sessionStackKey, branchingKey ], -1) as string,
          params: {
            pathId: path?._id,
            sessionId: session?._id,
            fromPath: encodeURIComponent(true),
            fromReckoning: encodeURIComponent(false),
          }});
      }
    }
  };



  return(
    <ProgramCardWrapper onCloseComplete={onCloseComplete} showOnboarding={showOnboarding} onboardingCb={onboardingCb} onboardingLabel={labels?.ONBOARDING_STEP_3}
      done={!!session?.done} onPress={onPressSession} line={exercisesBelow?'start': 'none'} marginBelow={MARGIN_BETWEEN_CARDS}>

      <Body1Bold>
        {session?.title}
      </Body1Bold>
      <BadgeAndActivity pathId={pathId} type={ActivityType.LESSON} />
    </ProgramCardWrapper>
  );

};

export const ProgramSessionCard= observer(_ProgressSessionCard);


